import Basepage, { BasePageState } from '../Basepage';
import $ from 'jquery';

import './index.scss';
import React from 'react';
import { getObjectFromForm, injectPhpDebug } from '../../../../mol_function';

import LabelInput, { SelectData } from '../../elements/LabelImput';
import AdressComponnent, {
  getEmptyAddressProp,
} from '../../elements/AdressComponnent';
import PasswordInput from '../../elements/PasswordInput';
import BuchhandlerInput from '../../elements/BuchhandlerInput';
import MolLink from '../Basepage/parts/Menu/MolLink';

import iconKundenservice from '../Basepage/parts/images/icon-kundenservice.svg';

import registerSuccessImg from './parts/11_Success-1.jpg';
import emailValidSuccessImg from './parts/3871751.jpg';

interface LoginState extends BasePageState {
  isLoginFail: boolean;
}
interface LoginModel {
  countrys: SelectData[];
}

export default class LoginPage extends Basepage<LoginState, LoginModel> {
  renderChild(): JSX.Element {
    let anyProp: any = this.props;
    let location = anyProp.location;

    let loginMessage: JSX.Element | null = null;

    if (location?.search.startsWith('?resetSuccess')) {
      loginMessage = (
        <div>
          <img
            src={iconKundenservice}
            style={{ width: '20px', marginRight: '5px' }}
          />
          <span className="loginError">
            Vielen Dank. Wir haben Ihnen soeben einen Link zum Bestätigen Ihres
            neuen Passworts per E-Mail gesendet.
          </span>
        </div>
      );
    } else if (
      location?.search != undefined &&
      location.search.startsWith('?reset=')
    ) {
      loginMessage = (
        <div>
          <img
            src={iconKundenservice}
            style={{ width: '20px', marginRight: '5px' }}
          />
          <span className="loginError">
            Sie haben erfolgreich Ihr neues Passwort aktiviert. Sie können sich
            nun sofort mit Ihrer E-Mail und Ihrem Passwort einloggen.
          </span>
        </div>
      );
    }

    if (location?.search == '?action=lost') {
      return (
        <div id="login">
          <form
            onSubmit={(event4) => {
              event4.preventDefault();

              let result = getObjectFromForm($(event4.target));

              let oneCommandItem = {
                command: 'lostPassword',
                commandParams: {
                  email: result.email,
                  password: result.password,
                },
              };

              let url = injectPhpDebug(
                this.state.apiBase +
                  '/CreateUser.php?oneCommand=' +
                  encodeURIComponent(JSON.stringify(oneCommandItem)),
              );
              fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
              })
                .then((res) => res.json())
                .then(
                  (result) => {
                    window.historyHelper.memory.push(
                      '/login?resetSuccess=' +
                        (result.body.lostPassword != 'userNotFound'),
                      null,
                    );
                  },
                  (error) => {
                    this.setState({ isLoginFail: true });
                  },
                );
            }}
          >
            Sie haben Ihr Passwort vergessen?
            <br />
            <br />
            Bitte tragen Sie hier Ihre <b>registrierte</b> Emailadresse ein und
            vergeben Ihr neues Passwort.
            <br />
            <br />
            Nach dem Absenden der Daten erhalten Sie von uns sofort eine E-Mail
            mit dem Bestätigungslink zum Zurücksetzen Ihres Passwortes.
            <br />
            <br />
            Bitte klicken Sie auf diesen Link, um das Zurücksetzen zu
            bestätigen. Sie können sich danach mit Ihrem neuen Passwort
            einloggen.
            <br />
            <br />
            Wenn Sie keine E-Mail von uns erhalten, haben Sie sich unter
            Umständen mit einer alternativen E-Mail-Adresse registriert oder
            unsere Mail hat sich in Ihren Spam Ordner verirrt, schauen Sie bitte
            dort einmal nach.
            <br />
            <br />
            <MolLink to="/kontakt" href="/kontakt">
              Bei Fragen hilft Ihnen gerne unser Kundenservice weiter.
            </MolLink>
            <br />
            <br />
            <LabelInput
              id="login-email-address"
              labelText="E-Mail Adresse"
              type="text"
              name="email"
              inputDynparam={{ size: 36, maxLength: 96 }}
            />
            <PasswordInput showLost={false} />
            <br />
            <input type={'submit'} />
          </form>
        </div>
      );
    } else if (location?.search == '?action=createUserSuccess') {
      return (
        <div>
          <img src={registerSuccessImg} style={{ width: '300px' }} />
          <br />
          Sie wurden erfolgreich registriert
          <br />
          Bitte bestätigen Sie Ihre E-Mail-Adresse.
        </div>
      );
    }

    //TODO: Ausblenden Keine Cookie
    else if (
      this.state.hasApiData &&
      this.state.apiData.body?.Activate != undefined
    ) {
      //TODO: Email Aktierung Page
      if (this.state.apiData.body?.Activate) {
        return (
          <div>
            <img src={emailValidSuccessImg} style={{ width: '300px' }} />
            <br />
            Ihr Kundenkonto wurde nun erfolgreich aktiviert!
            <br />
            <br />
            Der BUCHBUTLER wünscht Ihnen viel Spaß beim Einkaufen!
          </div>
        );
      } else
        return (
          <div>
            Ihr Kundenkonto wurde nun nicht erfolgreich aktiviert!
            <br />
            <br />
            Der BUCHBUTLER wünscht Ihnen viel Spaß beim Einkaufen!
          </div>
        );
    } else
      return (
        <div id="login">
          <div className="split">
            <form
              onSubmit={(event3) => {
                event3.preventDefault();

                let result = getObjectFromForm($(event3.target));
                let jsonBody = JSON.stringify(result);

                let url = injectPhpDebug(this.state.apiBase + '/Login.php');

                fetch(url, {
                  method: 'POST',
                  credentials: 'include',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                  },
                  body: jsonBody,
                })
                  .then((res) => res.json())
                  .then(
                    (result) => {
                      let isLoginFail = false;
                      if (result.body.login == 'ok') {
                        window.historyHelper.memory.push('/', null);
                      } else if (result.body.login == 'error') {
                        isLoginFail = true;
                      }
                      this.setState({ isLoginFail: isLoginFail });
                    },
                    (error) => {
                      this.setState({ isLoginFail: true });
                    },
                  );
              }}
            >
              <fieldset>
                <legend>
                  Sind Sie bereits Kunde? Bitte melden Sie sich an
                </legend>
                {loginMessage != null ? loginMessage : null}
                <LabelInput
                  id="login-email-address"
                  labelText="E-Mail Adresse"
                  type="text"
                  name="email"
                  inputDynparam={{ size: 36, maxLength: 96 }}
                />
                <PasswordInput showLost={true} />

                <LabelInput
                  id="securityToken"
                  labelText=""
                  type="hidden"
                  name="securityToken"
                  inputDynparam={{ value: '79f3b7e1f059fb33f643cc500f5ddba6' }}
                />
                {this.state.isLoginFail ? (
                  <>
                    <span className="loginError">
                      Anmeldung fehlgeschlagen: Falsche E-Mail Adresse oder
                      falsches Passwort.
                    </span>
                    <br />
                  </>
                ) : null}
                <input type="submit" value="Anmelden" className="logBtn" />
              </fieldset>
            </form>
          </div>
          <div className="split">
            <form
              //action={this.state.apiBase + '/Register.php'}
              //method="POST"
              onSubmit={(event2) => {
                event2.preventDefault();

                let form = $(event2.target);
                let formSerializeData = form.serialize();
                let keyValuePair = formSerializeData.split('&');
                let result = {};
                for (let i = 0; i < keyValuePair.length; i++) {
                  let kvSplit = keyValuePair[i].split('=');
                  if (kvSplit[1].trim() != '')
                    result[kvSplit[0]] = decodeURI(kvSplit[1]);
                  else result[kvSplit[0]] = null;
                }

                let jsonBody = JSON.stringify(result);

                let url = injectPhpDebug(this.state.apiBase + '/Register.php');
                let errorHandling = (error) => {
                  //TODO: Verbessertes Error Handling

                  if (error == 'emailExist') {
                    window.alert('Sie sind bereits registriert!');
                  } else window.alert('Registrierung ist fehlgeschlagen');
                };
                fetch(url, {
                  method: 'POST',
                  credentials: 'include',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                  },

                  body: jsonBody,
                })
                  .then((res) => res.json())
                  .then(
                    (result) => {
                      if (result.body.register == 'ok') {
                        window.historyHelper.memory.push(
                          '/login?action=createUserSuccess',
                          null,
                        );
                      } else if (result.body.register == 'error') {
                        //TODO: Reqest Error handling
                        errorHandling(result.body.error);
                      }
                    },
                    (error) => {
                      //TODO: Reqest Error handling
                      errorHandling(error);
                    },
                  );
              }}
            >
              <fieldset>
                <legend>
                  Sie sind neu hier? Dann erstellen Sie bitte ein Kundenkonto
                </legend>
                <AdressComponnent
                  {...getEmptyAddressProp(this.body.countrys)}
                />

                <LabelInput
                  id="telefon"
                  labelText="Telefon"
                  type="text"
                  name="telefon"
                />

                <LabelInput
                  id="email"
                  labelText="E-Mail Adresse"
                  type="text"
                  name="email"
                  requied={true}
                  inputDynparam={{ size: 36, maxLength: 96 }}
                />
                {/* TODO: Password Policy */}
                <LabelInput
                  id="password"
                  labelText="Passwort"
                  type="password"
                  name="password"
                  requied={true}
                  inputDynparam={{ size: 36, maxLength: 255 }}
                />

                <LabelInput
                  id="handelsregisternummer"
                  labelText="Handelsregisternummer"
                  type="text"
                  name="handelsregisternummer"
                />

                {this.state.isBuchhandler ? (
                  <BuchhandlerInput
                    isNotValidExit={false}
                    cookieDomain={this.state.apiData.cookieDomain}
                  />
                ) : null}
                <input
                  type="checkbox"
                  name="Datenschutzbestimmungen"
                  id="datenschutzbestimmungen"
                  required={true}
                />
                <label htmlFor="Datenschutzbestimmungen">
                  Datenschutzbestimmungen
                </label>
                <br className="clearBoth" />

                <input type="submit" className="logBtn" />
              </fieldset>
            </form>
            {/*TODO: Registrierung Bestatigung Seite */}
          </div>
        </div>
      );
  }

  initState(base: BasePageState): LoginState {
    let newState: LoginState = {
      ...base,
      isLoginFail: false,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    let anyProps: any = this.props;
    let oneCommand = '';

    if (
      anyProps.location != undefined &&
      (anyProps.location.search.includes('?action=') ||
        anyProps.location.search.includes('?token='))
    ) {
      let urlParams = new URLSearchParams(anyProps.location.search);
      let oneCommandItem: any = undefined;

      if (anyProps.location.search.includes('?action=')) {
        let actionString: string | null = urlParams.get('action');
        let actionWithOutApiCommand = ['lost', 'createUserSuccess'];

        if (
          actionString == null ||
          actionWithOutApiCommand.indexOf(actionString) == -1
        )
          oneCommandItem = {
            command: 'loginAction',
            commandParams: actionString,
          };
      } else if (anyProps.location.search.includes('?token=')) {
        let tokenString: string | null = urlParams.get('token');
        let emailString: string | null = urlParams.get('email');
        oneCommandItem = {
          command: 'emailActivate',
          commandParams: {
            token: tokenString,
            email: emailString,
          },
        };
      }

      if (oneCommandItem != undefined) {
        oneCommand = '?oneCommand=' + encodeURI(JSON.stringify(oneCommandItem));
        if (!checkOnly && this.state.oneCommand != oneCommand) {
          this.setState({ oneCommand: oneCommand });
        }
      }
    }
    return this.state.apiBase + '/CreateUser.php' + oneCommand;
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Login';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Login</span>;
  }
  getType(): string {
    return 'LoginPage';
  }
}
